module.exports = __webpack_public_path__ + "img/tcl_point.8df4d1ec.gif";